import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanToLabelPipe } from './pipes/boolean-to-label.pipe';
import { DateFormatterPipe } from './pipes/date-formatter.pipe';
import { HeaderComponent } from './components/header/header.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { GoogleLoginComponent } from './components/google-login/google-login.component';
import { GoogleLogOutComponent } from './components/google-log-out/google-log-out.component';
import { LogOutButtonComponent } from './components/log-out-button/log-out-button.component';
import { DxButtonModule, DxDataGridModule, DxLoadPanelModule, DxTextBoxModule } from 'devextreme-angular';
import { SystemPasswordComponent } from './components/system-password/system-password.component';
import { CircleProgressComponent } from './components/circle-progress/circle-progress.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports:[
    RouterModule,
    CommonModule,
    FlexLayoutModule, 
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatExpansionModule,
    MatListModule,
    MatIconModule,
    MatButtonToggleModule,
    MatRadioModule,
    DxLoadPanelModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxButtonModule,
    MatProgressSpinnerModule
  ],
  declarations: [ 
    BooleanToLabelPipe, 
    DateFormatterPipe, 
    HeaderComponent, 
    GoogleLoginComponent, 
    GoogleLogOutComponent, 
    LogOutButtonComponent,
    SystemPasswordComponent,
    CircleProgressComponent
  ],
  exports: [
    BooleanToLabelPipe, 
    DateFormatterPipe, 
    HeaderComponent,
    GoogleLoginComponent,
    GoogleLogOutComponent,
    LogOutButtonComponent,
    SystemPasswordComponent,
    CircleProgressComponent
  ],
})
export class SharedModule { }
